import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=ad74ee36&scoped=true&"
import script from "./compare.vue?vue&type=script&lang=js&"
export * from "./compare.vue?vue&type=script&lang=js&"
import style0 from "./compare.vue?vue&type=style&index=0&id=ad74ee36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad74ee36",
  null
  
)

export default component.exports